import { logout } from './authSlice';
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  profile: null,
  menu: [],
  status: 'idle',
  error: null,
  settings: null
};

const shopSlice = createSlice({
  name: 'shop',
  initialState,
  extraReducers: builder => { builder.addCase(logout, () => ({ ...initialState })); },
  reducers: {
    fetchShopStart(state) {
      state.status = 'loading';
      state.error = null;
    },
    fetchShopSuccess(state, action) {
      state.status = 'succeeded';
      state.profile = action.payload;
    },
    fetchShopFailure(state, action) {
      state.status = 'failed';
      state.error = action.payload;
    },
    setShopMenu(state, action) {
      state.menu = action.payload;
    },
    setShopSettings(state, action) {
      state.settings = action.payload;
    },
    clearShop(state) {
      Object.assign(state, initialState);
    }
  }
});

export const { fetchShopStart, fetchShopSuccess, fetchShopFailure, setShopMenu, setShopSettings, clearShop } = shopSlice.actions;
export default shopSlice.reducer;
